let loadedFields = []

toggleRadioCheck = (inputElement) => {
  const radioGroup = inputElement.closest('.ant-radio-group')
  const allRadios = radioGroup.querySelectorAll('.ant-radio')

  allRadios.forEach((radio) => {
    radio.classList.remove('ant-radio-checked')
  })

  const currentRadio = inputElement.parentElement
  if (!currentRadio.classList.contains('ant-radio-checked')) {
    currentRadio.classList.add('ant-radio-checked')
  }
}

handleCheckboxClick = (inputElement, callback) => {
  const currentCheckbox = inputElement.parentElement

  // some items are checked but not all of them
  if (currentCheckbox.classList.contains('ant-checkbox-indeterminate')) {
    currentCheckbox.classList.remove('ant-checkbox-indeterminate')
    currentCheckbox.classList.add('ant-checkbox-checked')
    if (callback) {
      callback(true)
    }
  } else {
    if (!currentCheckbox.classList.contains('ant-checkbox-checked')) {
      currentCheckbox.classList.add('ant-checkbox-checked')
      if (callback) {
        callback(true)
      }
    } else {
      currentCheckbox.classList.remove('ant-checkbox-checked')
      if (callback) {
        callback(false)
      }
    }
  }
}
